import React from "react";
import TextBlockLoader from "../loaders/TextBlockLoader";

export default function ToolsSection({ tools, loading }) {

  return (
    <div>
      <h3 className="text-xl font-semibold text-gray-800 mb-2 mt-6">Tools you'll need</h3>
      {loading ? (
        <TextBlockLoader />
      ) : tools.length > 0 ? (
        <div className="bg-white border border-gray-300 rounded-lg p-4 shadow-sm">
          <ul className="space-y-2">
            {tools.map((tool, index) => (
              <li key={index} className="flex items-center text-sm text-gray-700">
                {tool}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p className="text-gray-500">No tools available.</p>
      )}
    </div>
  );
}
